import React from 'react';

import { useIntl } from 'react-intl-next';

import { Stack, Text } from '@atlaskit/primitives';
import { type AgentAction } from '@atlassian/conversation-assistant-service';

import { AgentActionPill } from '../../../../../../common/ui/agent-actions/agent-action-pill';

import messages from './messages';

export const ActionsSection = ({ actions }: { actions: AgentAction[] }) => {
	const { formatMessage } = useIntl();

	if (!actions.length) {
		return <Text>{formatMessage(messages.noActions)}</Text>;
	}

	return (
		<Stack space="space.050">
			{actions.map((action) => (
				<AgentActionPill key={action.id} action={action} />
			))}
		</Stack>
	);
};
